import { observer } from 'mobx-react-lite';
import { useBlogTrans } from '../../blogHooks/useBlogTrans';
import Box from '../../uikit/Box';
import Frame from '../../uikit/Frame';
import BlogDocViewer from '../blogCommon/BlogDocViewer';
import BlogJsonld from '../BlogJsonld';
import BlogMetaHeader from '../BlogMetaHeader';
import { useBlogContext } from '../BlogProvider';

class ViewStore {
    constructor() {}
}

const BlogTermsPage = observer(({ type }: { type: 'terms' | 'privacy' }) => {
    const { lang } = useBlogContext();
    const { trans } = useBlogTrans();

    return (
        <Frame>
            <BlogMetaHeader title={trans(type)} />
            <BlogJsonld
                type="WebSite"
                title={trans('blogIndexTitle')}
                description={`${trans('blogIndexTitle')} ${trans(type)}`}
            />
            <Frame.Title title={trans(type)} />
            {type === 'terms' && (
                <>
                    <Box>
                        <BlogDocViewer docKey={`terms-summary-${lang}`} />
                    </Box>
                    <Box>
                        <BlogDocViewer docKey={'terms'} />
                    </Box>
                </>
            )}
            {type === 'privacy' && (
                <>
                    <Box>
                        <BlogDocViewer docKey={`privacy-summary-${lang}`} />
                    </Box>
                    <Box>
                        <BlogDocViewer docKey={'privacy'} />
                    </Box>
                </>
            )}
        </Frame>
    );
});

export default BlogTermsPage;
